// import React from "react";

// import { OpenInNewOutlined, PersonOutline } from "@mui/icons-material";
// import { Box, Link, TableCell, TableRow, Typography } from "@mui/material";
// import dayjs from "dayjs";
// import { connect } from "react-redux";
// import { NavLink } from "react-router-dom";

// import { selectAssessmentById } from "../../../redux/slices/myAssessmentsSlice";
import React from "react";

import { OpenInNewOutlined, PersonOutline } from "@mui/icons-material";
import { Box, Link, TableCell, TableRow, Typography } from "@mui/material";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";

import { selectAssessmentById } from "../../../redux/slices/myAssessmentsSlice";

dayjs.extend(relativeTime);

// import JobCriteriaPopup from "../JobCriteriaPopup";

/* =============================================================================
<AssessmentTableViewRow />
============================================================================= */
const AssessmentTableViewRow = ({ assessment }) => {
  // console.log(assessment)
  return (
    <TableRow hover role="checkbox" tabIndex={-1}>
      <TableCell align="center">
        <Box display="flex" alignItems="center" width="250px" gap={2}>
          <Box
            minWidth="10px"
            minHeight="10px"
            borderRadius="50%"
            bgcolor="#25c661"
          />
          <Typography
            fontSize="14px"
            textAlign="left"
            fontWeight={600}
            sx={{
              display: "-webkit-box",
              overflow: "hidden",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 3,
            }}
          >
            {assessment?.assessment_name}
          </Typography>
        </Box>
      </TableCell>
      {/* <TableCell>
        <Box display="flex">
          <Box
            sx={{
              bgcolor: assessment?.progress === 'Not Started' ? '#FFECEC' : assessment?.progress === 'processing' ? '#FFF8E9' : '#E8F8FB',
              borderRadius: "30px",
              px: 2,
              py: 1,
            }}
          >
            <Typography color={assessment?.progress === 'Not Started' ? '#FF7070' : assessment?.progress === 'processing' ? '#FFC336' : '#56CAE3'} fontSize="13px" fontWeight={600}>
              {assessment?.progress}
            </Typography>
          </Box>
        </Box>
      </TableCell> */}
      <TableCell align="center">
        <Box display="flex" justifyContent="center" gap={1}>
          <PersonOutline
            sx={{ width: "18px", height: "18px", color: "#999" }}
          />
          <Typography fontSize="13px">
            {assessment?.candidates_attempted || "0"}
          </Typography>
        </Box>
      </TableCell>
      <TableCell align="center">
        <Typography fontSize="13px" fontWeight={500}>
          {assessment?.last_activity
            ? dayjs(assessment.last_activity).fromNow()?.replace("a ", "A ")
            : "No activity"}
        </Typography>
      </TableCell>
      <TableCell align="center">
        <Typography fontSize="13px" fontWeight={500}>
          {dayjs(assessment?.created_at).format("DD/MM/YYYY")}
        </Typography>
      </TableCell>
      <TableCell align="center">
        <Link
          component={NavLink}
          sx={{ p: 1 }}
          to={`/interview-candidates/${assessment?.id}/assessment`}
        >
          <OpenInNewOutlined
            sx={{ width: "22px", height: "22px", color: "#0891B2" }}
          />
        </Link>
      </TableCell>
    </TableRow>
  );
};

const mapStateToProps = (state, props) => ({
  assessment: selectAssessmentById(state, props?.id),
});

/* Export
============================================================================= */
export default connect(mapStateToProps)(React.memo(AssessmentTableViewRow));
